import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { components } from '@/types/api.generated';

export type UndatedOrder = components['schemas']['UndatedOrder'];

/**
 * The 「无配送日订单 (Undated Order)」 pool (#2561): orders whose items carry
 * no delivery date and that have no delivery job. The same pool shows on every
 * day; `http.get` unwraps the `{ data }` envelope.
 */
export function useUndatedOrders() {
  return useQuery({
    queryKey: queryKeys.dispatch.undatedOrders(),
    queryFn: () => http.get<UndatedOrder[]>('/api/dispatch/undated-orders'),
    staleTime: 60 * 1000,
  });
}
